/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-mixed-spaces-and-tabs */
'use client'

import React, { useEffect, useState } from 'react'
import '../../sass/menu/Items.scss'
import DetailedPopUp from './DetailedPopUp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import Image from 'next/image'
import { allergensList } from '@/lib/utils/allergensPath'
import Divider from './Divider'
import { Currency, ITheme, Language } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'

interface ItemProps {
	icon?: IconProp
	iconStyle?: string
	detailedPopup?: boolean
	name: string
	description?: string
	detailText?: string
	allergens?: string[]
	isFood?: boolean
	descriptionIsSpanishName?: boolean
	price?: number
	halfprice?: number
	tapaprice?: number
	fourthprice?: number
	toFixedValue?: number
	allowHtmlInDescription?: boolean
	imageSource?: string
	theme: ITheme
	language: Language
	fontStyle: {
    fontFamily: NextFont;
    fontSize: string;
  },
	currency: Currency,
	orderingActive: boolean
	itemId: string
}

const Item: React.FC<ItemProps> = (props) => {
  const {
    icon,
    iconStyle,
    name,
    description,
    detailText,
    detailedPopup,
    allergens,
    price,
    halfprice,
    tapaprice,
    fourthprice,
    isFood,
    imageSource,
    theme,
    fontStyle,
    currency,
    language,
    itemId,
    orderingActive
	  } = props

  const [showFullItem, setShowFullItem] = useState(false)

  // Manejo del evento popstate
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (showFullItem) {
        setShowFullItem(false)
      }
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [showFullItem])

  // Función para abrir el popup y agregar una entrada al historial
  const openPopup = () => {
    if (!imageSource && !orderingActive) return
    setShowFullItem(true)
    window.history.pushState({ popup: true }, '')
  }

  // Función para cerrar el popup y retroceder en el historial
  const closePopup = () => {
    setShowFullItem(false)
    window.history.back()
  }

  const priceStyle = { backgroundColor: theme.items.bgPriceColor, color: theme.items.priceTextColor, fontSize: fontStyle.fontSize }
  const formatPrice = (price: number) => {
    if (currency === '€') {
      return `${price.toFixed(2)}${currency}`
    } else if (currency === '$' || currency === '£') {
      return `${currency} ${price.toFixed(2)}`
    }
    return `${price.toFixed(2)}${currency}`
  }

  return (
		<li>
			<article
				className={`item ${imageSource ? 'with-img' : ''}`}
				onClick={(e) => {
				  openPopup()
				}}
			>
				<div className='info'>
					<div className='first-line'>
						<h5 className={fontStyle.fontFamily.className} style={{ color: theme.items.nameColor, fontSize: fontStyle.fontSize }}>
							{icon && <FontAwesomeIcon icon={icon} className={`item-icon ${iconStyle}`} />}
							{name}
						</h5>
						{!imageSource && <hr style={{ borderColor: theme.items.lineToPriceColor }} className='line-to-price' />}
						{!imageSource && (
							<div className='prices'>
								{tapaprice !== 0 && tapaprice !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle}>
										 {formatPrice(tapaprice)}
									</span>
								)}

								{halfprice !== 0 && halfprice !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle}>
										 {formatPrice(halfprice)}
									</span>
								)}
								{price !== 0 && price !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle}>
										 {formatPrice(price)}
									</span>
								)}

							</div>
						)}
					</div>
					<p className={fontStyle.fontFamily.className} style={{ color: theme.items.descriptionColor, fontSize: fontStyle.fontSize }}>{description}</p>
					{allergens && allergens.length > 0
					  ? (
						<div className='allergens-container' onClick={(e) => e.stopPropagation()}>
							{allergens.map((allergen) => (
								<div
									key={allergen}
									data-allergen={language === 'es' ? allergensList[allergen].name_es : language === 'fr' ? allergensList[allergen].name_fr : allergensList[allergen].name_en}
									className='allergen__img-wrapper'
								>
									<Image
										className='allergen__img'
										width={40}
										height={40}
										src={allergensList[allergen].img}
										alt={allergen}
									/>
								</div>
							))}
						</div>
					    )
					  : <div style={{ height: '10px' }} />}
					{imageSource && (
						<div className='prices'>
							{tapaprice !== 0 && tapaprice !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle}>
									 {formatPrice(tapaprice)}
								</span>
							)}
							{halfprice !== 0 && halfprice !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle}>
									 {formatPrice(halfprice)}
								</span>
							)}
							{price !== 0 && price !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle}>
									 {formatPrice(price)}
								</span>
							)}
						</div>
					)}
				</div>

				{imageSource && (
					<div className='img-container'>
						<Image className='img' src={imageSource} alt={`imagen de ${name}`} width={200} height={200} />
					</div>
				)}
			</article>

			{imageSource ? <Divider theme={theme} /> : <div style={{ marginTop: 15 }} />}

			{showFullItem && detailedPopup && (
				<DetailedPopUp
					name={name}
					detailText={detailText}
					description={description}
					allergens={allergens}
					isFood={isFood}
					price={price}
					halfprice={halfprice}
					tapaprice={tapaprice}
					fourthprice={fourthprice}
					allergenImages={allergens}
					setShowFullItem={closePopup}
					imageSource={imageSource}
					theme={theme}
					fontStyle={fontStyle}
					currency={currency}
					language={language}
					orderingActive={orderingActive}
					itemId={itemId}
				/>
			)}
		</li>
  )
}

export default Item
